import React from 'react';
import { NamePath } from 'antd/lib/form/interface';
import type { CheckedStrategy } from 'rc-tree-select/lib/utils/strategyUtil';
import { FilterBar2Value } from '../types';
import { useWatch, FormInstance, FormItem, TreeSelect } from 'components';
import { Translations } from '../filter-bar-2';

export interface FilterContentSelectProps {
	name: NamePath;
	values?: FilterBar2Value[];
	placeholder?: string;
	className?: string;
	translations: Translations & { selectAllTagText?: string };
	onChange?: (value: any) => void;
	form: FormInstance;
	showCheckedStrategy?: CheckedStrategy;
}

export const FilterContentTreeSelect = ({
	name,
	values,
	placeholder,
	className,
	translations,
	onChange,
	form,
	showCheckedStrategy
}: FilterContentSelectProps) => {
	const treeValue = useWatch(name, form);

	return (
		<FormItem name={name}>
			<TreeSelect
				allowSelectAll
				emptyAsAll
				className={className}
				selectAllText={translations.selectAll}
				placeholder={placeholder}
				value={treeValue}
				treeData={values as FilterBar2Value[]}
				onChange={onChange}
				selectAllTagText={translations.selectAllTagText}
				showCheckedStrategy={showCheckedStrategy}
			/>
		</FormItem>
	);
};
